/**
 * The pages a download walks, heard while it walks them (`docs/adr/9074`).
 *
 * A file built from a collection reads it page by page through `collectPages` before a row is written,
 * and on a large run that is most of the wait. The download's progress says how far it has read —
 * «12.000 righe ricevute finora (12 pagine)» — without each of the hundred builders taking a callback:
 * the download listens while it runs, and every walk that starts reports each page it reads.
 *
 * **Never a figure that is not the download's.** A walk a screen's query makes (`useApiCollection`) is
 * not the file's, so the query layer walks `untracked`. With two downloads listening at once nobody can
 * say whose page it was, so neither hears it: their progress stays «in preparation» rather than
 * counting the other's rows. No total is taken from a page: an envelope's `total` or `matching` counts
 * what ITS filters match, which is not always what the file holds, so the rows read are said alone.
 */

/** One page read: how many rows it held. */
export type PageListener = (rows: number) => void;

const listeners = new Set<PageListener>();

/** Hear every page a tracked walk reads until the returned function is called. */
export function listenToPageWalks(listener: PageListener): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

/** A tracked walk read a page of `rows`: heard only when exactly one download is listening. */
export function reportPageRead(rows: number): void {
  if (listeners.size !== 1) return;
  for (const listener of listeners) listener(rows);
}
